import { Check } from "@phosphor-icons/react";

export const StepProgress = ({ steps, current }) => {
  return (
    <div className="sticky top-16 z-30 bg-white/85 backdrop-blur-xl border-b border-slate-200">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 py-4">
        <div className="flex items-center justify-between text-xs font-medium text-slate-500 mb-2">
          <span data-testid="step-progress-label">
            Schritt {current + 1} von {steps.length}
          </span>
          <span className="font-semibold text-slate-900">{steps[current]}</span>
        </div>
        <div className="flex items-center gap-1.5">
          {steps.map((_, idx) => (
            <div
              key={idx}
              className={`h-1.5 flex-1 rounded-full transition-all duration-300 ${
                idx < current
                  ? "bg-emerald-500"
                  : idx === current
                  ? "bg-blue-600"
                  : "bg-slate-200"
              }`}
              data-testid={`step-indicator-${idx}`}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export const StatusTimeline = ({ stages, currentStatus, history = [] }) => {
  const currentIdx = stages.findIndex((s) => s.key === currentStatus);
  return (
    <ol className="relative border-l-2 border-slate-200 ml-3 space-y-6">
      {stages.map((stage, idx) => {
        const done = idx < currentIdx;
        const active = idx === currentIdx;
        const histEntry = history.find((h) => h.status === stage.key);
        return (
          <li key={stage.key} className="ml-6" data-testid={`status-stage-${stage.key}`}>
            <span
              className={`absolute -left-[13px] flex h-6 w-6 items-center justify-center rounded-full ring-4 ring-white ${
                done ? "bg-emerald-500" : active ? "bg-blue-600 pulse-dot" : "bg-slate-200"
              }`}
            >
              {done ? <Check size={14} weight="bold" color="white" /> : null}
            </span>
            <h4 className={`font-semibold ${active ? "text-blue-700" : done ? "text-slate-900" : "text-slate-400"}`}>
              {stage.label}
            </h4>
            {histEntry && (
              <time className="text-xs text-slate-500">
                {new Date(histEntry.at).toLocaleString("de-DE")}
              </time>
            )}
            {active && <p className="text-sm text-slate-600 mt-1">In Bearbeitung…</p>}
          </li>
        );
      })}
    </ol>
  );
};

export const CLAIM_STAGES = [
  { key: "schaden_gemeldet", label: "Schaden gemeldet" },
  { key: "unterlagen_geprueft", label: "Unterlagen geprüft" },
  { key: "versicherung_informiert", label: "Versicherung informiert" },
  { key: "termin_bestaetigt", label: "Termin bestätigt" },
  { key: "fahrzeug_in_bearbeitung", label: "Fahrzeug in Bearbeitung" },
  { key: "fertig_zur_abholung", label: "Fertig zur Abholung" },
];

export const SATTLEREI_STAGES = [
  { key: "neu", label: "Buchung eingegangen" },
  { key: "fotos_pruefen", label: "Fotos werden geprüft" },
  { key: "bestaetigt", label: "Termin bestätigt" },
  { key: "angenommen", label: "Fahrzeug angenommen" },
  { key: "in_arbeit", label: "In Arbeit" },
  { key: "trocknung", label: "Trocknung / Aushärtung" },
  { key: "montage", label: "Montage" },
  { key: "fertig_zur_abholung", label: "Fertig zur Abholung" },
  { key: "abgeschlossen", label: "Abgeschlossen" },
];

export const TINT_STAGES = [
  { key: "neu", label: "Buchung eingegangen" },
  { key: "anzahlung_erhalten", label: "Anzahlung erhalten" },
  { key: "bestaetigt", label: "Termin bestätigt" },
  { key: "in_arbeit", label: "In Arbeit" },
  { key: "erledigt", label: "Erledigt — Fahrzeug fertig" },
];
